import React, { Fragment } from "react";

const InValidPage = () => {
  return (
    <Fragment>
      <h1>InValid</h1>
    </Fragment>
  );
};

export default InValidPage;
